// extracted by mini-css-extract-plugin
module.exports = {"storePopover":"store-sestion_storePopover__3LKCD","storePopoverIcon":"store-sestion_storePopoverIcon__Q9PUd","header-link-store":"store-sestion_header-link-store__zdpvs"};